module.exports = __webpack_public_path__ + "img/classic-country.1ccda38d.png";